import { Box, Grid } from "@mui/material";
import Input, { IOptions } from "../../input/Input-v2";
import { useEffect, useState } from "react";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import { useToast } from "../../../context/toast/ToastContext";
import { debounce } from "../../../utils/Helper";

export interface ProductWithQuantityResult<T = any> extends IOptions {
  quantity: number;
  ext?: T;
}

export interface ProductWithQuantityData extends IOptions {
  ext?: any;
  stock: number;
}

interface ProdductWithQuantity {
  label?: string;
  hideStock?: boolean;
  options: ProductWithQuantityData[];
  onChange(value: ProductWithQuantityResult): void;
  onKeyUp(value: string): void;
}

function accessNestedObject(obj: any, path: string) {
  const keys = path.split(".");
  let current = obj;

  for (const key of keys) {
    if (current && current.hasOwnProperty(key)) {
      current = current[key] || "-";
    }
  }

  return current;
}

export const useGenerateProductWithQuantity = ({
  dataSource,
  keyForText,
  keyForValue,
  keyForStock,
}: {
  dataSource?: any[];
  keyForText: string;
  keyForValue: string;
  keyForStock: string;
}) => {
  const [dataOptions, setDataOptions] = useState<ProductWithQuantityData[]>([]);

  useEffect(() => {
    if (dataSource) {
      const temp: ProductWithQuantityData[] = [];
      dataSource.forEach((item) => {
        temp.push({
          text: item[keyForText],
          value: item[keyForValue],
          stock: accessNestedObject(item, keyForStock),
          ext: item,
        });
      });
      setDataOptions(temp);
    }
  }, [dataSource]);

  return { data: dataOptions };
};

export default function ProductWithQuantity({
  label,
  hideStock,
  options,
  onChange,
  onKeyUp,
}: ProdductWithQuantity) {
  const { show } = useToast();
  const [quantity, setQuantity] = useState("");
  const [stock, setStock] = useState("");
  const [selectedProduct, setSelectedProduct] =
    useState<ProductWithQuantityData | null>(null);

  const handleOnChange = (quantity: string) => {
    setQuantity(quantity);
  };

  const handleOnChangeAutoComplete = debounce((value: string) => {
    onKeyUp(value);
  }, 250);

  const handleOnClickAutoComplete = (value: ProductWithQuantityData) => {
    setStock(value.stock > 0 ? value.stock.toString() : "0");
    setSelectedProduct(value);
  };

  const handleOnClick = () => {
    if (quantity && selectedProduct) {
      if (
        selectedProduct.ext.skip_stock !== 0 &&
        parseInt(quantity) > parseInt(stock)
      ) {
        show("Stock tidak cukup", "warning");
        return;
      }
      const temp: ProductWithQuantityResult = {
        quantity: parseInt(quantity),
        ...selectedProduct,
      };
      onChange(temp);
    }
  };

  return (
    <Box>
      <Grid container spacing={2}>
        <Grid item xs={8}>
          <Input.Autocomplete
            onClick={(e: any) => handleOnClickAutoComplete(e)}
            label={label ? label : "Produk"}
            onChange={(e) => handleOnChangeAutoComplete(e)}
            options={options}
          />
        </Grid>
        {!hideStock && (
          <Grid item xs={1.5}>
            <Input.Text
              disable={true}
              value={stock}
              label="Stock"
              type="number"
            />
          </Grid>
        )}
        <Grid item xs={1.5}>
          <Input.Text
            value={quantity}
            label="Jumlah"
            type="number"
            onChange={(e) => {
              handleOnChange(e);
            }}
          />
        </Grid>
        <Grid item xs={1} alignItems={"flex-end"} display={"flex"}>
          <AddCircleOutlineIcon
            style={{ cursor: "pointer" }}
            fontSize="large"
            onClick={handleOnClick}
          />
        </Grid>
      </Grid>
    </Box>
  );
}
